"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _core = require("@emotion/core");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var FirstAid = function FirstAid(props, ref) {
  return (0, _core.jsx)("svg", (0, _extends2.default)({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), (0, _core.jsx)("path", {
    fill: "currentColor",
    d: "M18.875 14.188h-4.688v4.687c0 .345-.28.625-.624.625h-3.126a.625.625 0 01-.624-.625v-4.688H5.125a.625.625 0 01-.625-.624v-3.126c0-.345.28-.624.625-.624h4.688V5.125c0-.345.28-.625.624-.625h3.126c.345 0 .624.28.624.625v4.688h4.688c.345 0 .625.28.625.624v3.126c0 .345-.28.624-.625.624z"
  }));
};

var _default = (0, _react.forwardRef)(FirstAid);

var _default2 = _default;
exports.default = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(FirstAid, "FirstAid", "/builds/bA1zbJom/0/gojob/ui-bits/src/Icons/FirstAid.tsx");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/Icons/FirstAid.tsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9JY29ucy9GaXJzdEFpZC50c3giXSwibmFtZXMiOlsiRmlyc3RBaWQiLCJwcm9wcyIsInJlZiJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7OztBQUFBOzs7Ozs7Ozs7Ozs7O0FBRUEsSUFBTUEsUUFBd0UsR0FBRyxTQUEzRUEsUUFBMkUsQ0FBQ0MsS0FBRCxFQUFRQyxHQUFSO0FBQUEsU0FDL0U7QUFBSyxJQUFBLEtBQUssRUFBRSxFQUFaO0FBQWdCLElBQUEsTUFBTSxFQUFFLEVBQXhCO0FBQTRCLElBQUEsT0FBTyxFQUFDO0FBQXBDLEtBQW9ERCxLQUFwRDtBQUEyRCxJQUFBLEdBQUcsRUFBRUM7QUFBaEUsTUFDRTtBQUNFLElBQUEsSUFBSSxFQUFDLGNBRFA7QUFFRSxJQUFBLENBQUMsRUFBQztBQUZKLElBREYsQ0FEK0U7QUFBQSxDQUFqRjs7ZUFTZSx1QkFBV0YsUUFBWCxDOzs7Ozs7Ozs7Ozs7OzBCQVRUQSxRIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0LCB7IGZvcndhcmRSZWYsIFJlZkZvcndhcmRpbmdDb21wb25lbnQsIFNWR1Byb3BzIH0gZnJvbSAncmVhY3QnO1xuXG5jb25zdCBGaXJzdEFpZDogUmVmRm9yd2FyZGluZ0NvbXBvbmVudDxTVkdTVkdFbGVtZW50LCBTVkdQcm9wczxTVkdTVkdFbGVtZW50Pj4gPSAocHJvcHMsIHJlZikgPT4gKFxuICA8c3ZnIHdpZHRoPXsyNH0gaGVpZ2h0PXsyNH0gdmlld0JveD1cIjAgMCAyNCAyNFwiIHsuLi5wcm9wc30gcmVmPXtyZWZ9PlxuICAgIDxwYXRoXG4gICAgICBmaWxsPVwiY3VycmVudENvbG9yXCJcbiAgICAgIGQ9XCJNMTguODc1IDE0LjE4OGgtNC42ODh2NC42ODdjMCAuMzQ1LS4yOC42MjUtLjYyNC42MjVoLTMuMTI2YS42MjUuNjI1IDAgMDEtLjYyNC0uNjI1di00LjY4OEg1LjEyNWEuNjI1LjYyNSAwIDAxLS42MjUtLjYyNHYtMy4xMjZjMC0uMzQ1LjI4LS42MjQuNjI1LS42MjRoNC42ODhWNS4xMjVjMC0uMzQ1LjI4LS42MjUuNjI0LS42MjVoMy4xMjZjLjM0NSAwIC42MjQuMjguNjI0LjYyNXY0LjY4OGg0LjY4OGMuMzQ1IDAgLjYyNS4yOC42MjUuNjI0djMuMTI2YzAgLjM0NS0uMjguNjI0LS42MjUuNjI0elwiXG4gICAgLz5cbiAgPC9zdmc+XG4pO1xuXG5leHBvcnQgZGVmYXVsdCBmb3J3YXJkUmVmKEZpcnN0QWlkKTtcbiJdfQ==